module.exports = __webpack_public_path__ + "images/puzzle/Puzzle/PNG/Piece06.0a02c42b0e21fadbfabe2ddb62ec7e61.png";